import { useState } from 'react'
import { useMutation } from '@apollo/client'
import { DELETE_AD_ASSET, GET_AD_ASSETS } from '@/graphql/ads/ad-assets-queries'

export const useDeleteCard = (campaignId, adId, onCardDeleted) => {
    const [showDeleteDialog, setShowDeleteDialog] = useState(false)
    const [cardToDelete, setCardToDelete] = useState(null)
    const [isDeleting, setIsDeleting] = useState(false)

    const [deleteAdAsset] = useMutation(DELETE_AD_ASSET, {
        refetchQueries: [{ query: GET_AD_ASSETS, variables: { campaignId, adId } }],
    })

    const handleDeleteCard = async (cardId, cards) => {
        const card = cards.find((c) => c.id === cardId)
        if (card) {
            setCardToDelete(card)
            setShowDeleteDialog(true)
        }
    }

    const confirmDeleteCard = async () => {
        if (!cardToDelete) return

        setIsDeleting(true)
        try {
            await deleteAdAsset({ variables: { id: cardToDelete.id } })

            // Notify parent component to remove from local state
            if (onCardDeleted) {
                onCardDeleted(cardToDelete.id)
            }
        } finally {
            setIsDeleting(false)
            setShowDeleteDialog(false)
            setCardToDelete(null)
        }
    }

    const cancelDelete = () => {
        if (!isDeleting) {
            setShowDeleteDialog(false)
            setCardToDelete(null)
        }
    }

    return {
        showDeleteDialog,
        cardToDelete,
        isDeleting,
        handleDeleteCard,
        confirmDeleteCard,
        cancelDelete,
    }
}
